module.exports = __webpack_public_path__ + "static/media/01-chs.9d03b664.png";